import {
  createSelector,
  createFeatureSelector,
  ActionReducerMap,
  // ActionReducer,
  // MetaReducer,
} from '@ngrx/store'
import * as fromSettings from './settings/reducers'
import * as fromOptionList from './option-list/reducers'

export const reducers: ActionReducerMap<any> = {
  settings: fromSettings.reducer,
  optionList: fromOptionList.reducer,
}

export const getSettingsState = createFeatureSelector<any>('settings')

export const getOptionListState = createFeatureSelector<any>('optionList')

export const getSettings = createSelector(getSettingsState, fromSettings.getSettings)

export const getOptionList = createSelector(getOptionListState, fromOptionList.getSettings)
